// extracted by mini-css-extract-plugin
module.exports = {"countBox":"userPurchasedCount_countBox__MLe1H"};